import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, isValidElement } from 'react';
import { Redirect } from 'react-router-dom';
export const Authorized = ({ selectedRole, roles, children, readOnlyRoles, hideOnDenied, hasFullAccess, }) => {
    if (!selectedRole) {
        return _jsx(_Fragment, {}, void 0);
    }
    const hasAccess = hasFullAccess || roles.includes(selectedRole.name);
    const hasReadOnlyAccess = readOnlyRoles === null || readOnlyRoles === void 0 ? void 0 : readOnlyRoles.includes(selectedRole.name);
    if (hasAccess) {
        return _jsx(_Fragment, { children: children }, void 0);
    }
    if (hasReadOnlyAccess) {
        return (_jsx(_Fragment, { children: Children.map(children, (child) => {
                if (isValidElement(child)) {
                    return cloneElement(child, { readOnly: true, disabled: true });
                }
                return child;
            }) }, void 0));
    }
    if (!hideOnDenied) {
        return _jsx(Redirect, { to: '/' }, void 0);
    }
    {
        return _jsx(_Fragment, {}, void 0);
    }
};
